module.exports = __webpack_public_path__ + "static/media/transolimpica-img3.210cad00.jpg";